var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewReceiptIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.113 1H2.06822C1.47769 1 1 1.48185 1 2.07754V17.5779L2.45625 19.0469L3.9125 17.5779L5.36875 19.0469L6.82499 17.5779L8.28124 19.0469L9.73749 17.5779L11.1937 19.0469L12.65 17.5779L14.1062 19.0469H14.1464L15.7696 17.4095V2.35823C15.7696 1.60816 16.3725 1 17.1161 1C17.8597 1 18.4626 1.60816 18.4626 2.35823V8.16542H15.7696",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84277 3.66963H13.7399",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84277 13.4907H13.7399",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84277 15.9624H13.7399",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90448 7.54005C9.90448 6.67302 9.20728 5.96974 8.34775 5.96974C7.48822 5.96974 6.79102 6.67302 6.79102 7.54005C6.79102 9.2741 9.90448 7.84725 9.90448 9.51892C9.90448 10.3859 9.20728 11.0892 8.34775 11.0892C7.48822 11.0892 6.79102 10.3859 6.79102 9.51892",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34717 5.20572V5.96982",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34717 11.0893V11.8549",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReceiptIconBlue);
export default __webpack_public_path__ + "static/media/ViewReceiptIconBlue.5dcbd8a28702f36c70f6881108ce964c.svg";
export { ForwardRef as ReactComponent };